import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-base" data-id="element-81" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="1cf0399ya32mg">
        <div className="text-center mb-16" data-id="element-83" data-mp="1cgb8zfbaakg7">
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-84" data-mp="2a1ysx0qjzaau">
            Everything you need to know
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-extrabold text-ink" data-id="element-85" data-mp="253oyiscnkdqa">
            Frequently asked questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-86" data-mp="1v5823fuy36wu">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-paper border border-silver-light rounded-xl overflow-hidden" data-id="element-87" data-mp="1v7c4ftd73xv0" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-88" data-mp="jorkbfvx4e6t">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-89" data-mp="1fnuf3jw6nsne">{faq.q}</span>
                <ChevronDown className={`text-accent transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-90" data-mp="11xil1fg1fjtm" />
              </button>
              <AnimatePresence initial={false} data-id="element-91" data-mp="rx88lx1tugfi">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-92" data-mp="wvt6vqxiqq1b">
                    <div className="px-6 pb-5 text-graphite border-t border-silver-light pt-4" data-id="element-93" data-mp="2kuvmuafhgylm">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}